import name from '../router/name'
const adminConfig = [
    {
        menu: '系统管理',
        key: 'systemManage',
        icon: 'code',
        childen: [
            {
                subMenu: '通知栏',
                routerName: name.topNoticeSetting,
                subKey: name.topNoticeSetting
            },
//            {
//                subMenu: '轮播图',
//                routerName: name.topBannerSetting,
//                subKey: name.topBannerSetting
//            },
//            {
//                subMenu: '广告位',
//                routerName: name.midAdSetting,
//                subKey: name.midAdSetting
//            },
//            {
//                subMenu: '小工具',
//                routerName: name.tools,
//                subKey: name.tools
//            }
        ]
    }
]
export default adminConfig;